import styled from '@emotion/styled';
import { Route, Switch } from 'react-router-dom';
import NewMembersReport from 'src/pages/NewMembers';
import GuestLeaders from 'src/pages/admin/GuestLeaders';
import AllGuests from 'src/pages/admin/all-guests';
import AllUsers from 'src/pages/auth/AllUsers';
import AdminGroups from 'src/pages/groups/groups-admin';
import AllGroupCompliances from 'src/pages/groups/Compliances';
import AllNewLeaders from 'src/pages/groups/allNewLeaders';
import AllWeddingRequests from 'src/pages/wedding-requests/allWeddingRequests';
import GeneracionesServicesTable from 'src/pages/generaciones/GeneracionesServicesTable';
import AllVolunteers from 'src/pages/experience/volunteers/AllVolunteers';
import SurveyAnswers from 'src/pages/crecer/surveys/SurveyAnswers';
import EventDates from 'src/pages/crecer/EventDates';
import ComunidadNetworkAdmin from 'src/pages/comunidad-network/ComunidadNetworkAdmin';
import Counseling from 'src/pages/Counseling';
import AllNewVolunteers from 'src/pages/experience/volunteers/AllNewVolunteers';
import AllConfirmedVolunteers from 'src/pages/experience/volunteers/AllConfirmedVolunteers';
import AllProspectLeaders from 'src/pages/experience/volunteers/allProspectLeaders';
import ViewAllServices from 'src/pages/events/listServices';
import ServiceFormPage from 'src/containers/events/service-creation/ServiceFormPage';
import LessonEditorPage from 'src/pages/admin/LessonEditorPage';
import RelationsTablePage from 'src/pages/crecer/RelationsTable';
import CrecerReport from 'src/containers/crecer/crecerReport';
import GuestSelfAttendance from 'src/containers/crecer/selfAttendance/guestSelfAttendance';
import PendingGroupMembers from 'src/containers/groups/pendingGroupMembers';

const AdminContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;

  .welcome-section {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;

    h2 {
      color: #2596c2;
      margin-bottom: 15px;
      font-size: 2rem;
    }

    p {
      color: #666;
      line-height: 1.6;
      margin-bottom: 20px;
    }

    .stats-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 20px;
      margin-top: 20px;

      .stat-card {
        background: #f8f9fa;
        padding: 20px;
        border-radius: 8px;
        border-left: 4px solid #2596c2;

        .stat-number {
          font-size: 2rem;
          font-weight: bold;
          color: #2596c2;
          margin-bottom: 5px;
        }

        .stat-label {
          color: #666;
          font-size: 0.9rem;
        }
      }
    }
  }
`;

const AdminPanel = () => {
  return (
    <AdminContainer>
      <Switch>
        {/* Plataforma */}
        <Route path="/admin/all-users" component={AllUsers} />
        <Route path="/admin/all-guests" component={AllGuests} />

        {/* Discipulado */}
        <Route path="/admin/guest-leaders" component={GuestLeaders} />
        <Route path="/admin/wedding-requests" component={AllWeddingRequests} />

        {/* Conexion */}
        <Route path="/admin/new-members" component={NewMembersReport} />

        {/* Experiencia */}
        <Route path="/admin/all-volunteers" component={AllVolunteers} />
        <Route path="/admin/all-confirmed-volunteers" component={AllConfirmedVolunteers} />
        <Route path="/admin/all-new-volunteers" component={AllNewVolunteers} />

        {/* Grupos */}
        <Route path="/admin/prospect-leaders" component={AllProspectLeaders} />
        <Route path="/admin/new-leaders" component={AllNewLeaders} />
        <Route path="/admin/groups/compliances" component={AllGroupCompliances} />
        <Route path="/admin/groups/Grupo_Discipulado/pending" component={PendingGroupMembers} />
        <Route
          exact
          path="/admin/groups/:kind"
          render={(routeProps) => (
            <AdminGroups key={routeProps.match.params.kind} {...routeProps} />
          )}
        />

        {/* Social */}
        <Route path="/admin/all-network" component={ComunidadNetworkAdmin} />
        <Route path="/admin/counseling" component={Counseling} />

        {/* Crecer Plus */}
        <Route path="/admin/crecerplus/lesson/:courseId/:lessonId" component={LessonEditorPage} />

        {/* Crecer */}
        <Route path="/admin/event-dates" component={EventDates} />
        <Route path="/admin/relations-table" component={RelationsTablePage} />
        <Route path="/admin/crecer/encuestas" component={SurveyAnswers} />
        <Route path="/admin/crecer/reports" component={CrecerReport} />
        <Route path="/admin/crecer/self-attendance" component={GuestSelfAttendance} />

        {/* Reservaciones */}
        <Route path="/admin/church-services/new" component={ServiceFormPage} />
        <Route path="/admin/church-services/:eventId/edit" component={ServiceFormPage} />
        <Route path="/admin/church-services" component={ViewAllServices} />

        {/* Generaciones */}
        <Route path="/admin/generaciones-services" component={GeneracionesServicesTable} />
      </Switch>
    </AdminContainer>
  );
};

export default AdminPanel;
